import React from "react";
import TypingGame from "./TypingGame";
import { useParams } from "react-router";
import StoryBooks, {StoryBook} from "../data/StoryBooks";


export const StoryRoute: React.FC = () => {
    const { storyKey } = useParams<{ storyKey: string }>();
    let story = StoryBooks.find(s => s.id === storyKey) as StoryBook;
    return <TypingGame story={story} />;
};